// externals
import 'regenerator-runtime/runtime';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as styled from 'styled-components';
import * as mobx from 'mobx';
import * as mobxReact from 'mobx-react';
import * as HttpTransport from 'elc-http-transport';
import * as HypoContainer from 'hypo-container';
import { setupServiceInfo } from 'elc-universal-utils';

setupServiceInfo(__serviceInfo__);

// Check if it running in the Node
const isNode =
    typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

if (!isNode) {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
}
function ajv() {}
ajv.prototype.validate = function () {
    return true;
};

const ElcRuntime = {
    React,
    ReactDom,
    styled,
    mobx,
    mobxReact,
    ajv,
    HttpTransport,
    HypoContainer
};

export { ElcRuntime };
